"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var eventAttendeeMultiselectFieldQueryType;
(function (eventAttendeeMultiselectFieldQueryType) {
    eventAttendeeMultiselectFieldQueryType[eventAttendeeMultiselectFieldQueryType["All"] = 0] = "All";
    eventAttendeeMultiselectFieldQueryType[eventAttendeeMultiselectFieldQueryType["InMeetingsOnly"] = 1] = "InMeetingsOnly";
    eventAttendeeMultiselectFieldQueryType[eventAttendeeMultiselectFieldQueryType["IsAttendingOnly"] = 2] = "IsAttendingOnly";
})(eventAttendeeMultiselectFieldQueryType || (eventAttendeeMultiselectFieldQueryType = {}));
exports.default = eventAttendeeMultiselectFieldQueryType;
